import * as generic from '../actions/generic';
import * as endPoints from '../actions/endpoints';

export const sendOTP = body => generic.getApiMiddlewareJson(
  endPoints.SEND_OTP,
  generic.POST,
  generic.REQUEST_SEND_OTP,
  generic.SUCCESS_SEND_OTP,
  generic.FAILED_SEND_OTP,
  body,
);

export const verifyOTP = body => generic.getApiMiddlewareJson(
  endPoints.VERIFY_OTP,
  generic.POST,
  generic.REQUEST_VERIFY_OTP,
  generic.SUCCESS_VERIFY_OTP,
  generic.FAILED_VERIFY_OTP,
  body,
);



// WEBPACK FOOTER //
// ./src/actions/authentication.js